// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import { QueryClient, QueryClientProvider } from "react-query";
// import { Provider } from "react-redux";
// import { store } from "./store";
// import { DarkModeProvider, useDarkMode } from "./context/DarkModeContext";
// import { FooterProvider, useFooter } from "./context/FooterContext";
// import { ChatProvider } from "./context/ChatContext"; // ADD THIS

// // Layout Components
// import Navbar from "./components/layout/Navbar";
// import Footer from "./components/layout/Footer";

// // Pages
// import Home from "./pages/Home";
// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import Dashboard from "./pages/Dashboard";
// import Notes from "./pages/Notes";
// import NoteDetail from "./pages/NoteDetail";
// import UploadNote from "./pages/UploadNote";
// import Profile from "./pages/Profile";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";
// import VerifyEmail from "./pages/VerifyEmail";
// import AdminDashboard from "./pages/AdminDashboard";
// import NotFound from "./pages/NotFound";
// import VerifyEmailSuccess from "./pages/VerifyEmailSuccess";
// import ModeratorDashboard from "./pages/ModeratorDashboard";
// import AdminReports from "./pages/AdminReports";
// import MyTickets from "./pages/MyTickets";
// import CGPACalculator from "./components/cgpa/CGPACalculator";
// import SGPACalculator from "./components/sgpa/SGPACalculator";
// import SGPASchemeManager from "./components/sgpa/SGPASchemeManager";
// import AdminSGPA from "./components/sgpa/AdminSGPA";
// import ResultChecker from "./pages/ResultChecker";
// import Leaderboard from "./pages/Leaderboard";
// import ChatPage from "./pages/ChatPage";
// import RecentResults from "./pages/RecentResults";
// import CompareResults from "./pages/CompareResults";
// import PYQs from "./pages/PYQs";
// import MQPs from "./pages/MQPs";
// import UploadPYQ from "./pages/UploadPYQ";
// import AdminUploadPYQ from "./pages/AdminUploadPYQ";
// import OAuthCallback from "./pages/OAuthCallback";
// import FAQ from "./pages/FAQ";
// import PrivacyPolicy from "./pages/PrivacyPolicy";

// // Protected Route
// import ProtectedRoute from "./components/ProtectedRoute";

// // Chat Components
// import ChatWidget from "./components/chat/ChatWidget"; // ADD THIS

// // Styles
// import "./App.css";

// const queryClient = new QueryClient();

// // Create a component to handle dynamic Toaster and Footer
// const AppContent = () => {
//   const { isDarkMode } = useDarkMode();
//   const { showFooter } = useFooter();

//   return (
//     <div className="app" style={{ backgroundColor: "var(--bg-primary)" }}>
//       <Navbar />
//       <main className="main-content">
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/register" element={<Register />} />
//           <Route path="/verify-email/:token" element={<VerifyEmail />} />
//           <Route path="/forgot-password" element={<ForgotPassword />} />
//           <Route path="/reset-password/:token" element={<ResetPassword />} />
//           <Route path="/notes" element={<Notes />} />
//           <Route path="/notes/:id" element={<NoteDetail />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/contact" element={<Contact />} />
//           <Route
//             path="/verify-email/success"
//             element={<VerifyEmailSuccess />}
//           />
//           <Route
//             path="/moderator"
//             element={
//               <ProtectedRoute>
//                 <ModeratorDashboard />
//               </ProtectedRoute>
//             }
//           />

//           {/* Protected Routes */}
//           <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute>
//                 <Dashboard />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/upload"
//             element={
//               <ProtectedRoute>
//                 <UploadNote />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/profile"
//             element={
//               <ProtectedRoute>
//                 <Profile />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin"
//             element={
//               <ProtectedRoute adminOnly={true}>
//                 <AdminDashboard />
//               </ProtectedRoute>
//             }
//           />

//           {/* 404 Route */}
//           <Route path="*" element={<NotFound />} />
//           <Route
//             path="/admin/reports"
//             element={
//               <ProtectedRoute adminOnly={true}>
//                 <AdminReports />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/my-tickets"
//             element={
//               <ProtectedRoute>
//                 <MyTickets />
//               </ProtectedRoute>
//             }
//           />
//           <Route path="/cgpa-calculator" element={<CGPACalculator />} />
//           <Route path="/sgpa-calculator" element={<SGPACalculator />} />
//           <Route path="/admin/sgpa" element={<SGPASchemeManager />} />
//           <Route
//             path="/admin/sgpa"
//             element={
//               <ProtectedRoute>
//                 <AdminSGPA />
//               </ProtectedRoute>
//             }
//           />
//           <Route path="/results" element={<ResultChecker />} />
//           <Route path="/leaderboard" element={<Leaderboard />} />
//           <Route
//             path="/chat"
//             element={
//               <ProtectedRoute>
//                 <ChatPage />
//               </ProtectedRoute>
//             }
//           />
//           <Route path="/recent-results" element={<RecentResults />} />
//           <Route path="/compare-results" element={<CompareResults />} />
//           <Route path="/pyqs" element={<PYQs />} />
//           <Route
//             path="/upload-pyq"
//             element={
//               <ProtectedRoute adminOnly={true}>
//                 <UploadPYQ />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/admin/upload-pyq"
//             element={
//               <ProtectedRoute adminOnly={true}>
//                 <AdminUploadPYQ />
//               </ProtectedRoute>
//             }
//           />
//           <Route path="/oauth-callback" element={<OAuthCallback />} />
//           <Route path="/mqps" element={<MQPs />} />
//           <Route path="/faq" element={<FAQ />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         </Routes>
//       </main>
//       {showFooter && <Footer />}

//       {/* Chat Widget - Only show when authenticated */}
//       <ChatWidget />

//       <Toaster
//         position="top-right"
//         toastOptions={{
//           duration: 3000,
//           style: {
//             background: isDarkMode ? "#2b2d31" : "#fff",
//             color: isDarkMode ? "#e0e0e0" : "#333",
//             borderLeft: `4px solid #ff6a00`,
//             borderRadius: "8px",
//             boxShadow: isDarkMode
//               ? "0 4px 12px rgba(0,0,0,0.3)"
//               : "0 4px 12px rgba(0,0,0,0.1)",
//             padding: "12px 16px",
//             fontSize: "14px",
//           },
//           success: {
//             style: {
//               background: isDarkMode ? "#2b2d31" : "#fff",
//               color: isDarkMode ? "#e0e0e0" : "#333",
//               borderLeft: `4px solid #28a745`,
//             },
//           },
//           error: {
//             style: {
//               background: isDarkMode ? "#2b2d31" : "#fff",
//               color: isDarkMode ? "#e0e0e0" : "#333",
//               borderLeft: `4px solid #dc3545`,
//             },
//           },
//           loading: {
//             style: {
//               background: isDarkMode ? "#2b2d31" : "#fff",
//               color: isDarkMode ? "#e0e0e0" : "#333",
//               borderLeft: `4px solid #ff6a00`,
//             },
//           },
//         }}
//       />
//     </div>
//   );
// };

// function App() {
//   return (
//     <Provider store={store}>
//       <QueryClientProvider client={queryClient}>
//         <DarkModeProvider>
//           <FooterProvider>
//             <ChatProvider>
//               {" "}
//               {/* ADD THIS */}
//               <Router
//                 future={{
//                   v7_startTransition: true,
//                   v7_relativeSplatPath: true,
//                 }}
//               >
//                 <AppContent />
//               </Router>
//             </ChatProvider>{" "}
//             {/* ADD THIS */}
//           </FooterProvider>
//         </DarkModeProvider>
//       </QueryClientProvider>
//     </Provider>
//   );
// }

// export default App;

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { store } from "./store";
import { DarkModeProvider, useDarkMode } from "./context/DarkModeContext";
import { FooterProvider, useFooter } from "./context/FooterContext";
import { ChatProvider } from "./context/ChatContext";

// Layout Components
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Notes from "./pages/Notes";
import NoteDetail from "./pages/NoteDetail";
import UploadNote from "./pages/UploadNote";
import Profile from "./pages/Profile";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import VerifyEmailSuccess from "./pages/VerifyEmailSuccess";
import ModeratorDashboard from "./pages/ModeratorDashboard";
import AdminReports from "./pages/AdminReports";
import MyTickets from "./pages/MyTickets";
import CGPACalculator from "./components/cgpa/CGPACalculator";
import SGPACalculator from "./components/sgpa/SGPACalculator";
import SGPASchemeManager from "./components/sgpa/SGPASchemeManager";
import AdminSGPA from "./components/sgpa/AdminSGPA";
import ResultChecker from "./pages/ResultChecker";
import Leaderboard from "./pages/Leaderboard";
import ChatPage from "./pages/ChatPage";
import RecentResults from "./pages/RecentResults";
import CompareResults from "./pages/CompareResults";
import PYQs from "./pages/PYQs";
import UploadPYQ from "./pages/UploadPYQ";
import MQPs from "./pages/MQPs";
import AdminUploadPYQ from "./pages/AdminUploadPYQ";
import OAuthCallback from "./pages/OAuthCallback";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminCreateAnnouncement from "./pages/AdminCreateAnnouncement";
import LearningRoadmap from "./pages/LearningRoadmap";
import TopicDetail from "./pages/TopicDetail";
import AdminDomains from "./pages/AdminDomains";
import AdminTopics from "./pages/AdminTopics";
import MyLearning from "./pages/MyLearning";
import CourseTopics from "./pages/CourseTopics";
import ExploreCourses from "./pages/ExploreCourses";

// Protected Route
import ProtectedRoute from "./components/ProtectedRoute";

// Chat Components
import ChatWidget from "./components/chat/ChatWidget";

// Styles
import "./App.css";

const queryClient = new QueryClient();

// Create a component to handle dynamic Toaster and Footer
const AppContent = () => {
  const { isDarkMode } = useDarkMode();
  const { showFooter } = useFooter();

  // Disable inspect element, right-click, and shortcuts
  useEffect(() => {
    // Disable right-click context menu
    const disableRightClick = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable keyboard shortcuts for dev tools
    const disableDevToolsKeys = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I (Windows/Linux)
      if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "i")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+J (Windows/Linux)
      if (e.ctrlKey && e.shiftKey && (e.key === "J" || e.key === "j")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === "U" || e.key === "u")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+C (Inspect Element)
      if (e.ctrlKey && e.shiftKey && (e.key === "C" || e.key === "c")) {
        e.preventDefault();
        return false;
      }
      // For Mac: Cmd+Option+I
      if (e.metaKey && e.altKey && (e.key === "I" || e.key === "i")) {
        e.preventDefault();
        return false;
      }
      // For Mac: Cmd+Option+J
      if (e.metaKey && e.altKey && (e.key === "J" || e.key === "j")) {
        e.preventDefault();
        return false;
      }
      // For Mac: Cmd+U
      if (e.metaKey && (e.key === "U" || e.key === "u")) {
        e.preventDefault();
        return false;
      }
      // For Mac: Cmd+Option+C
      if (e.metaKey && e.altKey && (e.key === "C" || e.key === "c")) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    window.addEventListener("keydown", disableDevToolsKeys);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      window.removeEventListener("keydown", disableDevToolsKeys);
    };
  }, []);

  return (
    <div className="app" style={{ backgroundColor: "var(--bg-primary)" }}>
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/notes" element={<Notes />} />
          <Route path="/notes/:id" element={<NoteDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/verify-email/success"
            element={<VerifyEmailSuccess />}
          />

          {/* FAQ & Privacy Policy */}
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* OAuth Callback */}
          <Route path="/oauth-callback" element={<OAuthCallback />} />

          <Route
            path="/moderator"
            element={
              <ProtectedRoute>
                <ModeratorDashboard />
              </ProtectedRoute>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <UploadNote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-tickets"
            element={
              <ProtectedRoute>
                <MyTickets />
              </ProtectedRoute>
            }
          />
          <Route path="/cgpa-calculator" element={<CGPACalculator />} />
          <Route path="/sgpa-calculator" element={<SGPACalculator />} />

          {/* Admin SGPA Routes */}
          <Route
            path="/admin/sgpa"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminSGPA />
              </ProtectedRoute>
            }
          />

          <Route path="/results" element={<ResultChecker />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route path="/recent-results" element={<RecentResults />} />
          <Route path="/compare-results" element={<CompareResults />} />
          <Route path="/pyqs" element={<PYQs />} />

          {/* MQPs Route */}
          <Route path="/mqps" element={<MQPs />} />

          <Route
            path="/upload-pyq"
            element={
              <ProtectedRoute adminOnly={true}>
                <UploadPYQ />
              </ProtectedRoute>
            }
          />

          {/* Admin Upload PYQ Route */}
          <Route
            path="/admin/upload-pyq"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminUploadPYQ />
              </ProtectedRoute>
            }
          />
          <Route path="/oauth-callback" element={<OAuthCallback />} />
          <Route path="/mqps" element={<MQPs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* Announcement Routes - ADDED */}
          <Route
            path="/admin/create-announcement"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminCreateAnnouncement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning"
            element={
              <ProtectedRoute>
                <LearningRoadmap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/:id"
            element={
              <ProtectedRoute>
                <TopicDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/domains"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDomains />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/topics"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminTopics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/browse"
            element={
              <ProtectedRoute>
                <LearningRoadmap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/my-learning"
            element={
              <ProtectedRoute>
                <MyLearning />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/course/:domainId"
            element={
              <ProtectedRoute>
                <CourseTopics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/topic/:topicId"
            element={
              <ProtectedRoute>
                <TopicDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/explore"
            element={
              <ProtectedRoute>
                <ExploreCourses />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {showFooter && <Footer />}

      {/* Chat Widget - Only show when authenticated */}
      <ChatWidget />

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: isDarkMode ? "#2b2d31" : "#fff",
            color: isDarkMode ? "#e0e0e0" : "#333",
            borderLeft: `4px solid #ff6a00`,
            borderRadius: "8px",
            boxShadow: isDarkMode
              ? "0 4px 12px rgba(0,0,0,0.3)"
              : "0 4px 12px rgba(0,0,0,0.1)",
            padding: "12px 16px",
            fontSize: "14px",
          },
          success: {
            style: {
              background: isDarkMode ? "#2b2d31" : "#fff",
              color: isDarkMode ? "#e0e0e0" : "#333",
              borderLeft: `4px solid #28a745`,
            },
          },
          error: {
            style: {
              background: isDarkMode ? "#2b2d31" : "#fff",
              color: isDarkMode ? "#e0e0e0" : "#333",
              borderLeft: `4px solid #dc3545`,
            },
          },
          loading: {
            style: {
              background: isDarkMode ? "#2b2d31" : "#fff",
              color: isDarkMode ? "#e0e0e0" : "#333",
              borderLeft: `4px solid #ff6a00`,
            },
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <DarkModeProvider>
          <FooterProvider>
            <ChatProvider>
              <Router
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <AppContent />
              </Router>
            </ChatProvider>
          </FooterProvider>
        </DarkModeProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
